// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__38bip","question":"Question_question__dJvD1","description":"Question_description__UmE0E"};